import { ChevronDown } from '@/assets/icons'
import { IconButton } from '@/components/icon-button/IconButton'

type ScrollToBottomButtonProps = {
  onClick: () => void
}

/**
 * Floating affordance shown over the message list when the user has scrolled away from the
 * bottom, so they can jump back to the latest message. Customizes IconButton wrapper to meet
 * the necessary size and positioning requirements for the ScrollToBottomButton.
 */
export default function ScrollToBottomButton({ onClick }: ScrollToBottomButtonProps) {
  return (
    <div className="pointer-events-none absolute inset-x-0 bottom-2 flex justify-center">
      <div className="relative size-7 rounded-full border border-brand-neutral-200 bg-white shadow-menu">
        <IconButton
          aria-label="Scroll to bottom"
          icon={<ChevronDown />}
          onClick={onClick}
          variant="plain"
          color="neutral"
          size="md"
          wrapperClassName="pointer-events-auto absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      </div>
    </div>
  )
}
